import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { RoleInformationComponent } from './role-information/role-information.component';
import { SystemParametersComponent } from './system-parameters/system-parameters.component';
import { TabsModule } from 'primeng/tabs';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'configuration-detail',
    standalone: true,
    imports: [ButtonModule, RouterModule, RoleInformationComponent, SystemParametersComponent, TabsModule, NgClass, NgIf],
    templateUrl: './configuration-detail.component.html',
    styleUrl: './configuration-detail.component.less',
})
export class ConfigurationDetailComponent {
    active: string = 'role';
    activeTab(tabName: string) {
        this.active = tabName;
    }
}
